export default "__VITE_ASSET__BLV1LYuK__"